"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  reqHeaders: {}
};

var actionsMap = {
  MINDSELF_SET_CLIENT_DEFAULT_REQ_HEADERS: function MINDSELF_SET_CLIENT_DEFAULT_REQ_HEADERS(state, action) {
    return _extends({}, state, {
      reqHeaders: _extends({}, state.reqHeaders, action.headers)
    });
  },
  MINDSELF_SET_AUTHORIZATION_INFO: function MINDSELF_SET_AUTHORIZATION_INFO(state, action) {
    var _action$payload = action.payload,
        userId = _action$payload.userId,
        Authorization = _action$payload.Authorization;

    return _extends({}, state, {
      reqHeaders: _extends({}, state.reqHeaders, {
        Authorization: Authorization
      }),
      userId: userId
    });
  }
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var reduceFn = actionsMap[action.type];
  if (!reduceFn) return state;
  return reduceFn(state, action);
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/reducers/httpClient.js
// module id = 517
// module chunks = 1